import React from 'react';
import { Switch, Icon, Typography } from 'antd';
import cn from 'classnames';
import styles from './ToggleAutoUpdate.module.scss';

const { Text } = Typography;

const ToggleAutoUpdate = ({ enabled, onChange }) => {  
  return (
    <div className={cn(styles.root, { [styles.activeContainer]: enabled })}>
      <Switch
        checkedChildren={<Icon type="check" />}
        unCheckedChildren={<Icon type="close" />}
        checked={enabled}
        onChange={onChange}
      />
      <Text className={cn(styles.text, { [styles.active]: enabled })}>
        Автообновление статистики
      </Text>
    </div>
  );
};

export default ToggleAutoUpdate;
